import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Flashcards from "@/pages/Flashcards";
import FlashcardStudy from "@/pages/FlashcardStudy";
import Dictionary from "@/pages/Dictionary";
import Templates from "@/pages/Templates";
import Assistant from "@/pages/Assistant";
import StudyPaths from "@/pages/StudyPaths";
import CaseLaw from "@/pages/CaseLaw";
import Research from "@/pages/Research";
import Admin from "@/pages/Admin";
import Reconciliation from "@/pages/Reconciliation";
import Support from "@/pages/Support";
import AdminSupport from "@/pages/AdminSupport";
import Subscribe from "@/pages/Subscribe";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PreviewList from "@/pages/PreviewList";
import CoursePreview from "@/pages/CoursePreview";
import States from "@/pages/States";
import Referrals from "@/pages/Referrals";
import Credits from "@/pages/Credits";
import RabbitHoleMap from "@/pages/RabbitHoleMap";
import Blacks from "@/pages/Blacks";
import Teachings from "@/pages/Teachings";
import Community from "@/pages/Community";
import StatuteLibrary from "@/pages/StatuteLibrary";
import MyPaths from "@/pages/MyPaths";
import BiometricPrompt from "@/components/BiometricPrompt";
import OracleWidget from "@/components/OracleWidget";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BiometricPrompt />
        <OracleWidget />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/preview" element={<PreviewList />} />
          <Route path="/preview/:slug" element={<CoursePreview />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/study-path" element={<ProtectedRoute><StudyPaths /></ProtectedRoute>} />
          <Route path="/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
          <Route path="/courses/:slug" element={<ProtectedRoute><CourseDetail /></ProtectedRoute>} />
          <Route path="/flashcards" element={<ProtectedRoute><Flashcards /></ProtectedRoute>} />
          <Route path="/flashcards/:slug" element={<ProtectedRoute><FlashcardStudy /></ProtectedRoute>} />
          <Route path="/dictionary" element={<ProtectedRoute><Dictionary /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
          <Route path="/assistant" element={<ProtectedRoute><Assistant /></ProtectedRoute>} />
          <Route path="/caselaw" element={<ProtectedRoute><CaseLaw /></ProtectedRoute>} />
          <Route path="/research" element={<ProtectedRoute><Research /></ProtectedRoute>} />
          <Route path="/states" element={<ProtectedRoute><States /></ProtectedRoute>} />
          <Route path="/statutes" element={<ProtectedRoute><StatuteLibrary /></ProtectedRoute>} />
          <Route path="/my-paths" element={<ProtectedRoute><MyPaths /></ProtectedRoute>} />
          <Route path="/map" element={<ProtectedRoute><RabbitHoleMap /></ProtectedRoute>} />
          <Route path="/blacks" element={<ProtectedRoute><Blacks /></ProtectedRoute>} />
          <Route path="/teachings" element={<ProtectedRoute><Teachings /></ProtectedRoute>} />
          <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
          <Route path="/credits" element={<ProtectedRoute><Credits /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/admin/reconciliation" element={<ProtectedRoute><Reconciliation /></ProtectedRoute>} />
          <Route path="/admin/support" element={<ProtectedRoute><AdminSupport /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
